import { isDev } from 'constants/env';
import React from 'react';
import { Router } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { queryClient } from 'query';
import { LanguageType } from 'types/enum';
import { I18N } from 'locales/I18N';
import { history } from 'index';
import { CommonStoreProvider } from 'store/commonStore';
import App from './App';

export const Root = () => {
    return (
        // <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <CommonStoreProvider>
                <Router history={history}>
                    <I18N defaultLocale={LanguageType.enUS}>
                        <App />
                        {isDev && <ReactQueryDevtools />}
                    </I18N>
                </Router>
            </CommonStoreProvider>
        </QueryClientProvider>
        // </Provider>
    );
};
